<div class="p-8 max-w-md mx-auto text-center">
  <!-- Large Checkmark Icon -->
  <div class="flex justify-center mb-6">
    <mat-icon class="text-green-500" style="font-size: 64px; height: 64px; width: 64px;">check_circle</mat-icon>
  </div>

  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-2">{{data.title}}</h2>
  
  <!-- Message -->
  <p class="text-gray-600 mb-8 text-lg">{{data.message}}</p>

  <!-- Actions -->
  <div class="flex justify-center gap-4">
    <button *ngIf="data.showClose" mat-stroked-button (click)="onClose()" class="px-6 py-2 border-gray-300 hover:bg-gray-50">
      Close
    </button>
    <button  *ngIf="data.showViewQuotes" mat-flat-button color="accent" (click)="onViewQuotes()" class="px-6 py-2">View Quotes</button>
    <button  *ngIf="data.showNewQuote" mat-flat-button color="primary" (click)="onNewQuote()" class="px-6 py-2"> New Quote</button>
  </div>
</div>